import React from 'react';

import Chart, {
  CommonSeriesSettings,
  Series,
  Reduction,
  ArgumentAxis,
  Label,
  Format,
  ValueAxis,
  Title,
  Legend,
  Export,
  Tooltip,
} from 'devextreme-react/chart';

const dataSource = [{
    date: new Date(2022, 2, 1),
    l: 24.00,
    h: 25.00,
    o: 25.00,
    c: 24.875,
  }, {
    date: new Date(2022, 2, 2),
    l: 23.625,
    h: 25.125,
    o: 24.00,
    c: 24.875,
  }, {
    date: new Date(2022, 2, 3),
    l: 26.25,
    h: 28.25,
    o: 26.75,
    c: 27.00,
  }, {
    date: new Date(2022, 2, 4),
    l: 26.50,
    h: 27.875,
    o: 26.875,
    c: 27.25,
  }, {
    date: new Date(2022, 2, 7),
    l: 26.375,
    h: 27.50,
    o: 27.375,
    c: 26.75,
  }, {
    date: new Date(2022, 2, 8),
    l: 25.75,
    h: 26.875,
    o: 26.75,
    c: 26.00,
  }];
  

const CandleStickChart = () => {
    const customizeTooltip = (arg) => {
        return {
          text: `مستحصل: ${arg.openValue} د.ع<br/>
    مجمد: $${arg.closeValue} د.ع<br/>
    بالانتظار: $${arg.highValue} د.ع<br/>
    تم التبليغ: $${arg.lowValue} د.ع<br/>`,
        };
      }
    return (
      <Chart
        id="chart"
        
        dataSource={dataSource}
      >
        <CommonSeriesSettings
          argumentField="date"
          type="candlestick"
        />
        <Series
          name="جباية الضرائب"
          openValueField="o"
          highValueField="h"
          lowValueField="l"
          closeValueField="c"
        >
          <Reduction color="red" />
        </Series>
        <ArgumentAxis workdaysOnly={true}>
          <Label format="shortDate" />
        </ArgumentAxis>
        <ValueAxis tickInterval={1}>
          <Title text="دينار عراقي" />
          <Label>
            <Format
              precision={0}
              type="decimal"
            />
          </Label>
        </ValueAxis>
        {/* <Legend itemTextPosition="center" /> */}
        <Legend verticalAlignment="top" horizontalAlignment="center"></Legend>
        <Export enabled={true} />
        <Tooltip
          enabled={true}
          location="edge"
          customizeTooltip={customizeTooltip}
        />
      </Chart>
    );
  

  
}

export default CandleStickChart;
